/**
 * How much one row takes, given what the line still needs.
 *
 * The question is asked twice. `MultiList` asks it to decide whether a row's
 * checkbox is still enabled, and `MultiSelect` asks it to write `line.quantity`.
 * Those answers have to agree — a row the ceiling refuses is a row that would
 * have taken nothing — so this is one function rather than two expressions that
 * happen to match.
 *
 * They had already drifted: a row with no readable value in `field` was 0 here
 * and `NaN` there, and `NaN` would have been written onto the line and into
 * every total summed from it. Unreachable in practice, because the `available`
 * partition only offers rows that have the field — but the two callers
 * disagreed about a case neither of them owned.
 */
const allocationFor = (row, field, remaining) =>
    Math.min(Number(row?.[field]) || 0, remaining)

export default allocationFor
